import React from 'react';
import './ButtonInsideLoader.module.scss';

export const ButtonInsideLoader = () => {
  return (
    <span className="btn_inside_loader"></span>
  );
};
